import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0dd61c5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "col-12 mt-3"
}
const _hoisted_2 = { class: "card border" }
const _hoisted_3 = {
  key: 1,
  class: "col-12"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card border" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "alert alert-warning m-0" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "alert-message" }, " Отчетов нет ")
    ])
  ])
], -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_table_lite = _resolveComponent("table-lite")!

  return (_ctx.table.rows.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_table_lite, {
            class: "table table-bordered",
            columns: _ctx.table.columns,
            "is-hide-paging": true,
            "is-loading": _ctx.table.isLoading,
            "is-slot-mode": true,
            rows: _ctx.table.rows,
            sortable: _ctx.table.sortable,
            total: _ctx.table.totalRecordCount,
            onDoSearch: _ctx.doSearch,
            onIsFinished: _cache[0] || (_cache[0] = ($event: any) => (_ctx.table.isLoading = false))
          }, {
            locomotive: _withCtx((data) => [
              _createVNode(_component_router_link, {
                to:  { name: 'LocationShow', params: { locomotiveId: data.value.locoId, sectionId: data.value.sectionId, date: _ctx.moment(_ctx.state.date).format('YYYY-MM-DD') } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" №" + _toDisplayString(data.value.sectionNumber) + " " + _toDisplayString(data.value.locoModel) + " (" + _toDisplayString(data.value.contractorName) + ") ", 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          }, 8, ["columns", "is-loading", "rows", "sortable", "total", "onDoSearch"])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
}